import {Component, Input, OnInit, ViewChild, SecurityContext} from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {StatsService} from '../../../services/stats.service';
import * as moment from 'moment';
import {Stats} from '../../../model/stats';
import {DashboardLineColors} from '../../../../../../core/components/model/DashboardLineColors';
import {Observable} from 'rxjs/Rx';
import {TooltipDirective} from 'ngx-bootstrap';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-last-portal-stats',
  templateUrl: './last-portal-stats.component.html',
  styleUrls: ['./last-portal-stats.component.scss']
})
export class LastPortalStatsComponent extends ModalExtended implements OnInit {

    @Input() langPortal: string;
    data: Object;
    enabled: boolean = false;

    statsData: Stats;
    chartType: string = 'line';
    lineChartLegend: boolean = true;
    lineChartOptions: any = { responsive: true };
    colors: Array<Object> = [];
    lastActions: Array<Object> = [];

    linesToShow: Object = {};
    lineColors: DashboardLineColors;

    constructor(private stats: StatsService) {
        super();
        this.statsData = new Stats();
        this.lineColors = new DashboardLineColors();

        this.linesToShow = {
            'OK - DOI_LINE_EXISTS' : '1',
            'OK - DOI_RIGHT_PERSON' : '1',
            'ABSENT_SUBSCRIBER' : '1',
            'KO' : '0',
            'UNKNOWN' : '0',
            'ERROR' : '0',
        }
    }

    findValue(header: string): string {
        return this.statsData.findValueByLabel(0, header);
    }


    compareWithCurrent(label: string, value: string): number {
        const idx = this.data['current'].findIndex( (obj) => {
            return obj['label'] == label;
        } );

        const result: any = parseFloat(this.data['current'][idx]['value']) - parseFloat(value);
        return result.toFixed(2);
    }

    ngOnInit() {

        this.enabled = true;
        let queryData: Object = {
            'start_date': moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
            'end_date': moment().format('YYYY-MM-DD HH:mm:ss'),
            'portal_lang' : this.data['lang_portal']
        };
        let queryLine: Object = {
            'start_date': moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
            'end_date': moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
            'portal_lang' : this.data['lang_portal']
        };

        if(this.data.hasOwnProperty('camp_name')){
            queryData['camp_name'] = this.data['camp_name'];
            queryLine['camp_name'] = this.data['camp_name'];
        }

        Observable
            .forkJoin(
                this.stats.getDashboardStats(queryData),
                this.stats.getDashboardPortalEvolution(queryLine),
                this.stats.getDashboardLastActions(queryLine)
            ).subscribe(
                (results) => {

                    let tableResult = results[0];
                    let lineResult = results[1];
                    this.lastActions = results[2];

                    this.statsData.setHeaders(tableResult);
                    this.statsData.setRowsAvg(tableResult);
                    this.statsData.setPieData(tableResult);

                    this.statsData.rowsAvg[0] = this.statsData.rowsAvg[0].filter( (obj) => {
                        return ( (obj['label'] != obj['value']) && (obj['label'] != 'Total'));
                    } );

                    this.statsData.setLineData(lineResult, this.getLinesToShow());
                    this.statsData.getLineData()['data'].forEach( (data: Object) => {
                        const colorData = this.lineColors.getColorData(data['label']);
                        if(colorData){
                            this.colors.push(colorData);
                        }
                    } );

                    this.enabled = false;
                }
            )

    }

    onExit(): void {
        this.close();
    }


    protected getLinesToShow(): Array<string> {
        let lines: Array<string> = [];
        for (let key in this.linesToShow){
            if(this.linesToShow[key] == '1'){
                lines.push(key);
            }
        }

        return lines;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/components/modal/last-portal-stats/last-portal-stats.component.ts